import Vue from "vue";
import axios from "axios";
import Router from "vue-router";

import login from "@/components/login/index";
import auth from "@/components/login/auth";
import home from "@/components/index";
import userLog from "@/components/user/userLog";
import loginLog from "@/components/user/loginLog";
import control from "@/components/kanban/control/";
import fbgg from "../../node_modules/common/src/components/alarm/fbgg";
import alarmNotice from "../../node_modules/common/src/components/alarm/alarmNotice";
import notice from "../../node_modules/common/src/components/alarm/notice";
import ascAnalyse from "../../node_modules/common/src/components/alarm/ascAnalyse";
import ascSelect from "../../node_modules/common/src/components/alarm/ascSelect";
import cmd from "@/components/cmd/index";
import liucheng from "@/components/liucheng/liucheng";
import NotFound from "@/components/NotFound.vue";

import base from "./base";
import event from "./event";
import locateLocus from "./locateLocus";
import pay from "./pay";
import qingsao from "./qingsao";
import qingyun from "./qingyun";
import report from "./report";
import rule from "./rule";
import work from "./work";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      name: "Login",
      path: "/login",
      component: login
    },
    {
      path: "/auth",
      component: auth
    },
    {
      path: "*",
      component: NotFound
    },
    {
      path: "/home",
      component: home,
      meta: { auth: true },
      children: [
        {
          path: "/",
          redirect: "/control"
        },
        ...base,
        ...event,
        ...locateLocus,
        ...pay,
        ...qingsao,
        ...qingyun,
        ...report,
        ...rule,
        ...work,
        {
          path: "/control",
          component: control
        },
        {
          path: "/liucheng",
          component: liucheng
        },
        {
          path: "/userLog",
          component: userLog
        },
        {
          path: "/loginLog",
          component: loginLog
        },
        {
          path: "/asc/select",
          component: ascSelect
        },
        {
          path: "/asc/analyse",
          component: ascAnalyse
        },
        {
          path: "/cmd",
          component: cmd
        },

        {
          path: "/fbgg",
          component: fbgg
        },
        {
          path: "/alarmNotice",
          component: alarmNotice
        },
        {
          path: "/notice",
          component: notice
        }
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    // 对路由进行验证
    var mydata = sessionStorage.getItem(axios.plat);
    if (mydata == null || mydata == "") {
      // 已经登陆
      next({ path: "/login" });
    } else {
      next(); // 正常跳转到你设置好的页面
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js